<template>
  <div class="wrapper offers">
    <Header :settings="settings"
            :settingsOpen="settingsOpen"
            :storeInExt="true"
            v-on:changesettings="updateSettings"
            v-on:settingstoggle="settingsToggle"
    />
    <Settings :open="settingsOpen"
              :settings="settings"
              v-on:settingstoggle="settingsToggle"
              v-on:refreshdeals="$emit('refreshdeals')"
    />
    <div class="autodetect-label" :class="{'autodetect-label-inactive': !settings.autoDetect}">
      <span class="check-mark" v-if="settings.autoDetect"></span>
      Auto detect
      <span v-if="!settings.autoDetect">is off</span>
      <span v-else>is ON</span>
      <div class="autodetect-label-description" v-if="settings.autoDetect">
        Never miss a deal again with Cashback Alert
      </div>
    </div>
    <div class="offers-wrapper" :class="{'no-offers-bg': !offers.length}">
      <div v-if="settings.autoDetect" class="">
        <div class="offers-list" v-if="offers.length">
          <div class="offers-wrapper-title">Latest offers</div>
          <div class="offers-item" v-for="(item, index) in offers" :key="index">
            <div class="offers-item-main">
              <img :src="item.computed_logo || item.icon || imgPlaceholder()" :alt="item.name">
              <a href="#" class="btn-main"
                 target="_blank"
                 @click.prevent="goToStore(item)"
              >
                Get Deal
              </a>
            </div>
            <div class="offers-item-content">
              <div class="offers-item-title">
                {{item.name}}
              </div>
              <div class="offers-item-text">
                {{item.description}}
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="no-offers-content">
            <p class="offers-text"><b>Visit the sites</b> of our partners and we will show <br> <b>the best deals</b></p>
            <img src="../assets/img/double-chevron-bottom.svg" alt="arrow down">
          </div>
          <div class="offers-list-recommended">
            <router-link class="offers-item-recommended" v-for="item in recommended" :key="item.id"
                         target="_blank"
                         :to="{name: 'Loader', query: {
                               url: '#/?store=' + item.storeId,
                               title: item.title,
                               icon: item.icon,
                             }}">
              <img :src="item.icon" :alt="item.title">
              <span class="offers-list-btn-group">
                <span class="offers-list-btn">
                  See deals
                </span>
                <span class="offers-list-icon">
                  <img src="../assets/img/chevron-right.svg" alt="chevron">
                </span>
              </span>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <img class="offers-off-img" src="../assets/img/cta-ext-banner.svg" alt="cta">
        <div class="text-center">
          <button class="btn-main btn-big" @click="turnOnAutoDetect">Turn On</button>
        </div>
        <p class="offers-text">so that we can help you find the best deals</p>
      </div>
    </div>
  </div>
</template>

<script>

import Header from "@/components/Header";
import Settings from "@/components/Settings";
import {reportEvent} from "../utils";
export default {
  components: {Header, Settings},
  name: 'OffersExt',
  data: function (){
    return {
      settings: {
        extensionInstalled: false,
        autoDetect: true,
        enableNotification: true,
        showNotification: true,
        lastRefresh: localStorage.getItem('lastrefresh') || null
      },
      settingsOpen: false,
      offers: [],
      recommended: [
        {
          id: 1,
          title: 'Ebay',
          storeId: 76,
          icon:  require('../assets/img/static-offers/ebay-logo.svg'),
          link: 'https://www.ebay.com/'
        },
        {
          id: 2,
          storeId: 590,
          title: 'Aliexpress',
          icon: require('../assets/img/static-offers/aliexpress-logo.svg'),
          link: 'https://aliexpress.com'
        },
        {
          id: 3,
          storeId: 723,
          title: 'Nike',
          icon: require('../assets/img/static-offers/nike-logo.svg'),
          link: 'https://nike.com'
        }
      ]
    }
  },
  methods: {
    turnOnAutoDetect(){
      window.postMessage({
            sender: 'caSite',
            message: {
              autoDetect: true,
            }
          },
          "*");
      this.settings.autoDetect = true
    },
    updateSettings(setting) {
      Object.assign(this.settings, setting)
    },
    settingsToggle(value){
      this.settingsOpen = value
    },
    imgPlaceholder() {
      return require('../assets/img/cashback-icon.svg');
    },
    goToStore(item) {
      const routeData = this.$router.resolve({
        name: 'Loader', query: {
          url: '#/?store=' + item.id,
          title: item.name,
          icon: item.computed_logo || item.icon,
        }
      });
      reportEvent('click_store', {
        name: item.host
      }).then(() => {
        window.open(routeData.href, '_blank');
      }).catch(() => {
        window.open(routeData.href, '_blank');
      })
    }
  },
  mounted() {
    window.onmessage = (e) => {
      if (e.data.sender === 'cs') {
        this.offers = e.data.message.latestOffers
        this.settings.autoDetect = e.data.message.autoDetect
        this.settings.enableNotification = e.data.message.enableNotification
        this.settings.showFloatPopup = e.data.message.showFloatPopup
        this.settings.showNotification = e.data.message.showNotification
        this.settings.extensionInstalled = true
      }
    }

    window.postMessage({
          sender: 'caSite',
          message: {
            ping: true
          },
        },
        "*")
  }
}
</script>

<style lang="scss">
.offers {
  .saved-btn {
    display: none;
  }

  &-wrapper {
    background: linear-gradient(34.69deg, #F2F0FF 59.33%, #ECE9FF 100%);
    border-radius: 24px 24px 0 0;
    margin-top: 12px;
    padding: 0 16px 12px;
    text-align: center;
    color: #514E68;
    flex: 1;
    overflow: auto;

    &.no-offers-bg {
      background: url("../assets/img/static-offers/no-history-bg.svg") no-repeat top 13px left, linear-gradient(34.69deg, #F2F0FF 59.33%, #ECE9FF 100%);
    }

    &-title {
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
      margin-top: 18px;
    }
  }

  &-text {
    font-size: 18px;
    max-width: 250px;
    margin: 11px auto;
  }

  &-separator {
    background-color: #A2AFCE;
    width: 68px;
    height: 1px;
    margin: 4px auto;
  }

  &-footer {
    font-size: 16px;
    color: #514E68;
    padding: 20px 120px 20px 20px;
    background: #fff url("../assets/img/offers-bg.svg") no-repeat right/contain;
    box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &-list {

    &-btn-group {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 17px;
      color: #907AE0;
      font-weight: bold;
    }

    &-btn {
      background: #E4E0FF;
      border-radius: 60px;
      padding: 6px 12px;

      &:hover {
        background: #cfc8ff;
      }
    }

    &-icon {
      width: 28px;
      height: 28px;
      background: #E4E0FF;
      border-radius: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 12px;

      &:hover {
        background: #cfc8ff;
      }
    }
  }

  &-item {
    display: flex;
    background: #FFFFFF;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-bottom: 8px;

    &-text {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &-main {
      flex: 0 0 35%;
      padding: 18px;
      border-right: 1px dashed #D2D9EA;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      img  {
        margin-bottom: 10px;
      }
    }

    &-content {
      padding: 28px 16px 16px;
      color: #514E68;
      font-size: 14px;
      text-align: left;
    }

    &-title {
      font-weight: 700;
      margin-bottom: 10px;
    }

    &-recommended {
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      height: 78px;
      padding: 20px 20px 20px 25px;
      background: #fff;
      margin-bottom: 8px;
      border-radius: 8px;

      &:last-child {
        border-bottom: 0;
      }

      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
  &-off-img {
    width: 100%;
  }
}

.no-offers-content {
  margin: 89px 11px 37px auto;
  width: 160px;

  p {
    text-align: left;
  }
}

.autodetect-label {
  background: #EEEBFF;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
  padding: 12px;
  text-align: center;
  margin: 16px 16px 0;

  &-inactive {
    color: #D35A5A;
  }

  .autodetect-label-description {
    font-size: 16px;
    font-weight: 400;
  }
  .check-mark {
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 10px;
    border-radius: 50%;
    position: relative;
    background-color: #D2CBF7;

    &:after {
      content: "";
      display: block;
      width: 10px;
      height: 13px;
      border: solid 3px #0ECBA9;
      transform: rotate(45deg);
      border-top: 0;
      border-left: 0;
      position: absolute;
      left: 4px;
      top: -2px;

    }
  }
}

.btn-big {
  font-size: 16px;
  min-width: 186px;
  min-height: 48px;
}
</style>
